import React, {useContext, useEffect, useRef} from "react";
import {View, Animated, Platform} from "react-native";
import styles from './screen-styles';
import PtHeader from "../components/pt-header/pt-header";
import PtText from "../components/core/pt-text/pt-text";
import {styleVars} from "../app-style-vars";
import {getTranslation} from "../helpers/getTranslation";
import PtCopyright from "../components/pt-copyright/pt-copyright";
import {useSelector} from "react-redux";
import {SafeAreaView} from "react-native-safe-area-context";
import UserContext from "../helpers/UserContext";

/** set this to styles.withBoundaries to display borders around container views to catch layout overflows */
const showBoundaries = null;

export default function ScreenTemplate(props:any) {

  const isAuthenticated: boolean = useSelector((state:any) => state.authReducer.isAuthenticated);

  /** fixing header on scroll */
  const headerFixedHeight = styleVars.headerFixedSectionHeight;
  const headerDiscardHeight = props.route.params.headerOptions.showLogo ? styleVars.headerLogoSectionHeight : 0;
  const headerHeight = headerFixedHeight + headerDiscardHeight;
  const scrollY = new Animated.Value(0);
  const scrollYRef = useRef(scrollY);
  const handleScroll = Animated.event(
    [{
      nativeEvent: {
        contentOffset: {y: scrollYRef.current},
      },
    },],
    {
      useNativeDriver: true,
    },
  );
  /** inputRange: [0, headerHeight, headerHeight+1] = parallax scroll (header scrolls slower than scroll view, approx 2x) */
  /** inputRange: [0, headerDiscardHeight, headerDiscardHeight+1] = normal scroll (header scroll speed is the same as scroll view) */
  const translateY = scrollYRef.current.interpolate({
    inputRange: [0, headerHeight, headerHeight + 1],
    outputRange: [0, -headerDiscardHeight, -headerDiscardHeight],
  });

  const fullScreenContainerStyle = props.route.params.noTabs ? styles.pageContainerFullScreen : null;

  const {userData, updateUserData} = useContext(UserContext);

/*
  useEffect(() => {
    if(isAuthenticated !== userData.authenticated) {
      console.log('update auth from screen template, previous user data state = ', userData);
      updateUserData({...userData, authenticated: isAuthenticated});
    }
  }, [isAuthenticated])
*/

  return (
    <SafeAreaView style={[styles.pageContainer, fullScreenContainerStyle, showBoundaries]}>
      <Animated.View style={[styles.fixedHeaderContainer, {transform:[{translateY}]}]}>
        <PtHeader headerOptions={props.route.params.headerOptions}/>
      </Animated.View>
      <Animated.ScrollView
        contentContainerStyle={{paddingBottom: Platform.OS !== 'web' ? headerHeight : 0, minHeight: '100%'}}
        style={[styles.pageScrollContainer, showBoundaries, {paddingTop: headerHeight},]}
        scrollEventThrottle={16}
        onScroll={props.route.params.headerOptions.showLogo ? handleScroll : () => {return null}}
      >

        <View style={styles.inScrollContentContainer}>

          <View style={{marginBottom: props.route.params.showCopyright ? 20 : 0}}>
            {props.route.params.screenTitle ?
              <View style={styles.pageInfoContainer}>
                <PtText style={[styles.pageInfoText, {textAlign:'left'}]}>{getTranslation(props.route.params.screenTitle)}</PtText>
              </View>
              : null
            }

            {props.children}

          </View>

          <View style={styles.inScrollBottomContentContainer}>
            {props.route.params.showCopyright ? <PtCopyright/> : null}
          </View>

        </View>

      </Animated.ScrollView>
    </SafeAreaView>
  )
}
